import { GridSortDirection } from "@mui/x-data-grid"

export const castToBackendSort = (sortDirection: GridSortDirection | undefined) => sortDirection === "asc" ? "ASC" : "DESC"
